// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validatePhilippinePhone(phoneNumberValue: string): ?UserInputValidationError {
  if(!(phoneNumberValue && phoneNumberValue.trim())) {
    return { id: 'empty' };
  }

  if(!parseInt(phoneNumberValue)) {
    return { id: 'only-numbers' };
  }

  if(phoneNumberValue.length < 8) {
    return { id: 'min-length' };
  }
}
